import * as React from 'react';
import {NetworkRequestStatus, NetworkResult} from '../../../Network/NetworkResult';
import {observer} from 'mobx-react';

interface OwnProps<T> {
    result: NetworkResult<T>;
    loader: () => any;
    error: () => any;
    component: (data: T) => any;
}

export const ObservableNetworkRequestStatusView = observer(
    class NetworkRequestStatusView<T> extends React.Component<OwnProps<T>> {
        public render() {
            switch (this.props.result.status) {
                case NetworkRequestStatus.Loading:
                    return this.props.loader();
                case NetworkRequestStatus.Error:
                    return this.props.error();
                case NetworkRequestStatus.Success:
                    return this.props.component(this.props.result.data);
            }
        }
    }
);
